<script>
  import imageUpload from '../../../components/ImageUpload/index.vue'
  import RichTextEditor from '@/components/RichTextEditor/RichTextEditor.vue'
  export default {
    name: 'MarketingDialogConfig',
    components: {
      imageUpload,
      RichTextEditor
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Object,
        default: () => ({
          mainPicture: '',
          // backgroundPicture: '',
          // buttonColor: '',
          activityRule: ''
        })
      }
    },
    data() {
      return {
        rules: {
          mainPicture: [{ required: true, message: '请上传主弹窗图', trigger: 'change' }],
          // backgroundPicture: [
          //   { required: true, message: '请上传活动规则弹窗背景图', trigger: 'change' }
          // ],
          // buttonColor: [{ required: true, message: '请选择按钮颜色', trigger: 'change' }],
          activityRule: [{ required: true, message: '请输入活动规则', trigger: 'blur' }]
        },
        imageUploadLimit: {
          size: 1, // 1MB
          types: ['image/jpeg', 'image/png']
        },
        colorPickerVisible: false
      }
    },
    computed: {
      form: {
        get() {
          return this.value
        },
        set(newVal) {
          this.$emit('change', newVal)
        }
      }
    },
    methods: {
      validateForm() {
        return new Promise((resolve, reject) => {
          this.$refs.form.validate((valid) => {
            if (valid) {
              resolve(this.form)
            } else {
              reject(new Error('表单验证失败'))
            }
          })
        })
      },
      handleImageUpload(file, fieldName) {
        // 验证文件类型
        if (!this.imageUploadLimit.types.includes(file.type)) {
          this.$message.error('只支持jpg/png格式图片')
          return false
        }

        // 验证文件大小
        if (file.size / 1024 / 1024 > this.imageUploadLimit.size) {
          this.$message.error(`图片大小不能超过${this.imageUploadLimit.size}MB`)
          return false
        }

        // 创建预览
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.form[fieldName] = reader.result
        }

        // 阻止自动上传
        return false
      },
      handleRemoveImage(fieldName) {
        this.form[fieldName] = ''
      },
      confirmColor() {
        this.colorPickerVisible = false
      },
      getImg(url, prop) {
        console.log('上传的图片', url)
        this.form[prop] = url
      }
    }
  }
</script>

<template>
  <div class="marketing-dialog-config">
    <div class="title">营销弹窗配置：</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="150px" class="config-form">
      <!-- 主弹窗图 -->
      <el-form-item label="主弹窗图" prop="mainPicture">
        <!--        :code="'marketingConfig'"-->
        <imageUpload
          :imageList="form.mainPicture ? [{ url: form.mainPicture }] : []"
          :limit="1"
          :fileSize="1"
          :isShowTip="true"
          :WHtip="true"
          :width="640"
          :height="720"
          :fileType="['png', 'jpg']"
          accept=".jpg,.png"
          :multiple="false"
          code="advertising"
          @input="
            (val) => {
              getImg(val, 'mainPicture')
            }
          "
        />
      </el-form-item>

      <!-- 活动规则弹窗背景图 -->
      <!--      <el-form-item label="活动规则弹窗背景图" prop="backgroundPicture">-->
      <!--        <imageUpload-->
      <!--          :imageList="form.backgroundPicture ? [{ url: form.backgroundPicture }] : []"-->
      <!--          :limit="1"-->
      <!--          :fileSize="1"-->
      <!--          :isShowTip="true"-->
      <!--          :WHtip="true"-->
      <!--          :width="616"-->
      <!--          :height="658"-->
      <!--          :fileType="['png', 'jpg']"-->
      <!--          accept=".jpg,.png"-->
      <!--          :multiple="false"-->
      <!--          @input="-->
      <!--            (val) => {-->
      <!--              getImg(val, 'backgroundPicture')-->
      <!--            }-->
      <!--          "-->
      <!--        />-->
      <!--      </el-form-item>-->

      <!-- 活动规则 -->
      <el-form-item label="活动规则" prop="activityRule">
        <RichTextEditor style="width: 415px" v-model="form.activityRule" />
      </el-form-item>

      <!-- 立即下单按钮颜色 -->
      <!--      <el-form-item label="立即下单按钮颜色" prop="buttonColor">-->
      <!--        <el-color-picker v-model="form.buttonColor" show-alpha />-->
      <!--        &lt;!&ndash;        <div class="color-picker-wrapper">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <el-input v-model="form.buttonColor" class="color-input" :disabled="true">&ndash;&gt;-->
      <!--        &lt;!&ndash;            <template slot="append">&ndash;&gt;-->
      <!--        &lt;!&ndash;              <div&ndash;&gt;-->
      <!--        &lt;!&ndash;                class="color-block"&ndash;&gt;-->
      <!--        &lt;!&ndash;                :style="{ backgroundColor: form.buttonColor || '#FFFFFF' }"&ndash;&gt;-->
      <!--        &lt;!&ndash;                @click="colorPickerVisible = true"&ndash;&gt;-->
      <!--        &lt;!&ndash;              ></div>&ndash;&gt;-->
      <!--        &lt;!&ndash;            </template>&ndash;&gt;-->
      <!--        &lt;!&ndash;          </el-input>&ndash;&gt;-->

      <!--        &lt;!&ndash;          <div v-if="colorPickerVisible" class="color-picker-panel">&ndash;&gt;-->
      <!--        &lt;!&ndash;            <el-color-picker v-model="form.buttonColor" show-alpha></el-color-picker>&ndash;&gt;-->
      <!--        &lt;!&ndash;            <div class="color-picker-actions">&ndash;&gt;-->
      <!--        &lt;!&ndash;              <el-button type="primary" size="mini" @click="confirmColor">确定</el-button>&ndash;&gt;-->
      <!--        &lt;!&ndash;              <el-button size="mini" @click="colorPickerVisible = false">取消</el-button>&ndash;&gt;-->
      <!--        &lt;!&ndash;            </div>&ndash;&gt;-->
      <!--        &lt;!&ndash;          </div>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
      <!--      </el-form-item>-->
    </el-form>
  </div>
</template>

<style scoped lang="scss">
  .marketing-dialog-config {
    padding: 20px;
    //border: 1px dashed #f56c6c;
    border-radius: 4px;

    .title {
      font-weight: bold;
      margin-bottom: 10px;
    }

    .config-form {
      max-width: 650px;
    }

    .image-uploader {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 178px;
      height: 178px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        border-color: #409eff;
      }

      .image-uploader-icon {
        font-size: 28px;
        color: #8c939d;
      }

      .image-preview {
        width: 178px;
        height: 178px;
        position: relative;

        .preview-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .image-actions {
          position: absolute;
          top: 0;
          right: 0;
          padding: 5px;
          line-height: 20px;
          background-color: rgba(0, 0, 0, 0.5);
          border-bottom-left-radius: 4px;

          i {
            color: #fff;
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
    }

    .upload-tip {
      color: #f56c6c;
      font-size: 12px;
      margin-top: 5px;
    }

    .color-picker-wrapper {
      position: relative;
      width: 220px;

      .color-input {
        width: 100%;
      }

      .color-block {
        width: 20px;
        height: 20px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
      }

      .color-picker-panel {
        position: absolute;
        top: 40px;
        left: 0;
        z-index: 10;
        background-color: #fff;
        padding: 10px;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        .color-picker-actions {
          margin-top: 10px;
          text-align: right;
        }
      }
    }
  }
</style>
